// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"4d16ca55","408":"9ee6e8b5"}[chunkId] + ".chunk.js";
};